import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';
import { MENU_ITEM_SUB_ANSWER } from '../../../utils/Constants';
import MessageUtils from "../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_ANSWERS_SUCCESS,
    REORDER_ANSWERS_SUCCESS,
    LOAD_SUB_ANSWERS_SUCCESS,
    REORDER_SUB_ANSWERS_SUCCESS,
    RESET_SUB_QUESTIONS,
    RESET_SUB_ANSWERS,
    RESET_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS,
    RESET_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS
} from '../../types';
import { convertStringToBoolean } from '../../../utils/CommonUtils';

export const loadAnswers = (questionDraftId, column) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/question-draft/${questionDraftId}/answers`;

        if (column !== undefined) {
            axios().get(url)
                .then(response => loadSubAnswersSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.loadSubAnswersFailure')));
        } else {
            axios().get(url)
                .then(response => loadAnswersSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.loadAnswersFailure')));
        }
    }
}

const loadSubAnswersSuccess = (dispatch, response, saveMessageSuccess, publishMessageSuccess) => {

    if (saveMessageSuccess !== undefined && saveMessageSuccess !== null && saveMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:answersActions.saveAnswerSuccess'));
    }

    if (publishMessageSuccess !== undefined && publishMessageSuccess !== null && publishMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:answersActions.publishAnswerSuccess'));
    }

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_SUB_ANSWERS_SUCCESS, payload: response.data });
}

const loadAnswersSuccess = (dispatch, response, saveMessageSuccess, publishMessageSuccess) => {

    if (saveMessageSuccess !== undefined && saveMessageSuccess !== null && saveMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:answersActions.saveAnswerSuccess'));
    }

    if (publishMessageSuccess !== undefined && publishMessageSuccess !== null && publishMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:answersActions.publishAnswerSuccess'));
    }

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: RESET_SUB_QUESTIONS });
    dispatch({ type: RESET_SUB_ANSWERS });
    dispatch({ type: LOAD_ANSWERS_SUCCESS, payload: response.data });
}

export const saveAnswer = (state, restaurantId, itemType, publishAnswerCallback, selectedCategoryAndProductIDs) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        const {
            id,
            questionDraftId,
            name,
            description,
            mealDealProduct,
            active,
            multipleActivateOrDeactivate,
            multipleNameChange,
            multipleDescriptionChange,
            answerGroupObject,
            price,
            currentQuestionDraftId, nutrients, snoozeValue } = state;
        const answerId = id !== -1 ? id : '';
        const url = `/answer-draft/${answerId}`;

        let modifiedNutrients = [];
        nutrients.map(nutri => {
            let nutriObj = {
                nutrition: {
                    id: nutri.id,
                    nutritionCode: nutri.nutritionCode
                },
                value: nutri.value
            };

            modifiedNutrients.push(nutriObj);
        });

        const answerData = {
            restaurantId: Number(restaurantId),
            questionDraftId: questionDraftId,
            name: name,
            description: description,
            mealDealProduct: mealDealProduct,
            active: convertStringToBoolean(active),
            multipleActivateOrDeactivate: convertStringToBoolean(multipleActivateOrDeactivate),
            multipleNameChange: convertStringToBoolean(multipleNameChange),
            multipleDescriptionChange: convertStringToBoolean(multipleDescriptionChange),
            answerGroup: !answerGroupObject || !answerGroupObject.id || answerGroupObject.id === -1 ? null : answerGroupObject,
            price: price,
            nutrients: modifiedNutrients,
            inactiveTimePeriod: snoozeValue && snoozeValue !== 'custom' ? snoozeValue : null
        };
        let currQuestionDraftId = id === -1 ? questionDraftId : currentQuestionDraftId;
        let secondCondition = selectedCategoryAndProductIDs ? (selectedCategoryAndProductIDs.length) ? true : false : false;

        if (selectedCategoryAndProductIDs && secondCondition) {
            const urlMealDeals = `/question-draft/${currQuestionDraftId}/assign`;
            axios().put(urlMealDeals, selectedCategoryAndProductIDs)
                .then(response => saveAnswerSuccess(dispatch, currQuestionDraftId, itemType, publishAnswerCallback))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
        } else if (id !== -1) {
            axios().put(url, answerData)
                .then(response => saveAnswerSuccess(dispatch, currQuestionDraftId, itemType, publishAnswerCallback))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
        } else {
            axios().post(url, answerData)
                .then(response => saveAnswerSuccess(dispatch, currQuestionDraftId, itemType, publishAnswerCallback))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
        }
    }
};

const saveAnswerSuccess = (dispatch, questionDraftId, itemType, publishAnswerCallback) => {

    if (publishAnswerCallback) {
        publishAnswerCallback();
    }

    const url = `/question-draft/${questionDraftId}/answers`;

    if (itemType === MENU_ITEM_SUB_ANSWER) {
        axios().get(url)
            .then(response => loadSubAnswersSuccess(dispatch, response, true, itemType))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.loadAnswersFailure')));
    } else {
        axios().get(url)
            .then(response => loadAnswersSuccess(dispatch, response, true))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.loadAnswersFailure')));
    }
};

export const publishAnswer = (state, itemType) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/answer-draft/${state.id}/publish`;
        const { questionDraftId } = state;

        axios().put(url, {})
            .then(response => publishAnswerSuccess(dispatch, response, questionDraftId, itemType))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.publishAnswerFailure')));
    }
};

const publishAnswerSuccess = (dispatch, response, questionDraftId, itemType) => {

    if (response.data.code === 403) {
        MessageUtils.errorMessageResponse(dispatch, response.data, i18n.t('actions:menusActions.alreadyRunningPublish'))
    } else {
        const url = `/question-draft/${questionDraftId}/answers`;

        if (itemType === MENU_ITEM_SUB_ANSWER) {
            axios().get(url)
                .then(response => loadSubAnswersSuccess(dispatch, response, false, true))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.loadAnswersFailure')));
        } else {
            axios().get(url)
                .then(response => loadAnswersSuccess(dispatch, response, false, true))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.loadAnswersFailure')));
        }
    }
};

export const reorderAnswers = (answers, questionId, isSubItem) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/question-draft/${questionId}/answers/reorder`;

        if (isSubItem) {
            axios().put(url, answers)
                .then(response => reorderSubAnswersSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.reorderSubAnswersFailure')));
        } else {
            axios().put(url, answers)
                .then(response => reorderAnswersSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:answersActions.reorderItemsFailure')));
        }
    }
}

const reorderSubAnswersSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: REORDER_SUB_ANSWERS_SUCCESS, payload: response.data });
}

const reorderAnswersSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: REORDER_ANSWERS_SUCCESS, payload: response.data });
}

export const resetCategoriesInCatProdReducer = () => {
    return (dispatch) => {
        // console.log('resetCategoriesInCatProdReducer ')
        dispatch({ type: RESET_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS });
        dispatch({ type: RESET_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS });
    }
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/posmenu/AnswersActions.js